import script from "./MMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MMenu.vue?vue&type=script&setup=true&lang=js"

import "./MMenu.vue?vue&type=style&index=0&id=29941bdb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29941bdb"]])

export default __exports__